module.exports = __webpack_public_path__ + "img/johndeere_thumbnail.080a3e9b.png";